import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "relative flex-inline"
};
import { generateColorMap } from "@/modules/vue/utils";
import { ColorEnum } from "@/modules/vue/enums";
export default /*#__PURE__*/_defineComponent({
  __name: 'BadgeDot',
  props: {
    orientation: {
      default: 'bottom-right'
    },
    disabled: {
      type: Boolean
    },
    color: {
      default: ColorEnum.Green
    }
  },
  setup(__props) {
    const props = __props;
    const colorClassMap = generateColorMap({
      bg: 400
    });
    const colorClasses = computed(() => colorClassMap[props.disabled ? ColorEnum.Gray : props.color]);
    const orientationClasses = computed(() => ({
      'top-right': 'top-1 right-1',
      'bottom-right': 'bottom-1 right-1',
      'bottom-left': 'bottom-1 left-1',
      'top-left': 'top-1 left-1'
    }));
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["absolute bottom-1 right-1 w-2 h-2 rounded-full bg-green-500", {
          [_unref(colorClasses)]: true,
          [_unref(orientationClasses)[__props.orientation]]: true
        }])
      }, null, 2), _renderSlot(_ctx.$slots, "default")]);
    };
  }
});